var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccountMenuDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 28,
    viewBox: "0 0 26 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 3.81836C3.25 2.88496 2.52383 2.13086 1.625 2.13086C0.726172 2.13086 0 2.88496 0 3.81836V21.5371C0 23.868 1.81797 25.7559 4.0625 25.7559H24.375C25.2738 25.7559 26 25.0018 26 24.0684C26 23.135 25.2738 22.3809 24.375 22.3809H4.0625C3.61562 22.3809 3.25 22.0012 3.25 21.5371V3.81836ZM23.8977 8.38516C24.5324 7.72598 24.5324 6.65547 23.8977 5.99629C23.2629 5.33711 22.232 5.33711 21.5973 5.99629L16.25 11.5545L13.3352 8.52754C12.7004 7.86836 11.6695 7.86836 11.0348 8.52754L5.34727 14.4338C4.7125 15.093 4.7125 16.1635 5.34727 16.8227C5.98203 17.4818 7.01289 17.4818 7.64766 16.8227L12.1875 12.1135L15.1023 15.1404C15.7371 15.7996 16.768 15.7996 17.4027 15.1404L23.9027 8.39043L23.8977 8.38516Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountMenuDashboard);
export default __webpack_public_path__ + "static/media/account-menu-dashboard.0a38fa54b36d0cfcfd22e9c307a8b52c.svg";
export { ForwardRef as ReactComponent };